<template>
  <div id="app">
    <router-view></router-view>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "app",
  data(){
    return{
      dialogVisible:false
    }
  },
  methods:{
  }
};
</script>

<style >


.el-message-box__btns {
  text-align: center !important;
}
html {
  background-color: #eef7fd;
}
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
@media (min-width: 768px) {
  .container {
    width: 736px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 956px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1216px;
  }
}
@media (min-width: 1314px) {
  .container {
    width: 1330px;
  }
}
@media screen and (max-width: 420px){
      .el-message-box{
        width:80% !important;
      }
}

.container {
  margin-right: auto;
  margin-left: auto;
  padding-left: 8px;
  padding-right: 8px;
}
</style>
